export const CURRENCIES = "CURRENCIES";
export const CURRENCIES_SUCCESS = "CURRENCIES_SUCCESS";
export const CURRENCIES_ERROR = "CURRENCIES_ERROR";
export const CURRENCIES_CLEAR_DATA = "CURRENCIES_CLEAR_DATA";
